import {
  ICreateAbnNoticeRequest,
  ICreateAbnNoticeResponse,
} from "types/AbnNotice/AbnNotice";

import { publicApi } from ".";

const publicAbnNoticesQueries = publicApi.injectEndpoints({
  endpoints: (builder) => ({
    createAbnNotice: builder.mutation<
      ICreateAbnNoticeResponse,
      ICreateAbnNoticeRequest
    >({
      query: (abnNotice) => ({
        url: "abn-notices",
        method: "POST",
        body: {
          orderId: abnNotice.orderId,
          signatureImageBase64: abnNotice.signatureImageBase64,
          templateType: abnNotice.templateType,
          abnOption: abnNotice.abnOption,
          procedures: abnNotice.procedures,
          documentHashData: abnNotice.documentHashData,
          signatureIpAddress: abnNotice.signatureIpAddress,
          userAgent: abnNotice.userAgent,
        },
      }),
    }),
  }),
});

export const { useCreateAbnNoticeMutation } = publicAbnNoticesQueries;
